// extracted by mini-css-extract-plugin
export default {"title":"RocketCard_title__q4roJ","box":"RocketCard_box__epNCd","box__inner":"RocketCard_box__inner__72uuY"};